import React from 'react';

import { Colors } from 'constants/theme';

const CloseIcon: React.FC<
  React.SVGProps<SVGSVGElement> & {
    color?: string;
  }
> = ({ ...props }) => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M13.3 2.1C13.6866 1.7134 13.6866 1.0866 13.3 0.7C12.9134 0.313401 12.2866 0.313401 11.9 0.7L7 5.6L2.1 0.7C1.7134 0.3134 1.0866 0.313401 0.7 0.7C0.313401 1.0866 0.313401 1.7134 0.7 2.1L5.6 7L0.7 11.9C0.3134 12.2866 0.313401 12.9134 0.7 13.3C1.0866 13.6866 1.7134 13.6866 2.1 13.3L7 8.4L11.9 13.3C12.2866 13.6866 12.9134 13.6866 13.3 13.3C13.6866 12.9134 13.6866 12.2866 13.3 11.9L8.4 7L13.3 2.1Z"
      fill={props.color || Colors.sage4}
      fillRule="evenodd"
    />
  </svg>
);

const CloseMenuIcon: React.FC<
  React.SVGProps<SVGSVGElement> & {
    color?: string;
  }
> = ({ ...props }) => (
  <svg
    fill="none"
    height={14}
    viewBox="0 0 14 14"
    width={14}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M13.3 2.1A.99.99 0 1011.9.7L7 5.6 2.1.7A.99.99 0 10.7 2.1L5.6 7 .7 11.9a.99.99 0 101.4 1.4L7 8.4l4.9 4.9a.99.99 0 101.4-1.4L8.4 7l4.9-4.9z"
      fill={props.color || Colors.sage4}
      fillRule="evenodd"
    />
  </svg>
);

const CloseIconThin: React.FC<
  React.SVGProps<SVGSVGElement> & {
    color?: string;
  }
> = ({ ...props }) => (
  <svg
    fill="none"
    height="25"
    viewBox="0 0 24 25"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.66699 17.5376L17.0379 7.1667"
      stroke={props.color || Colors.sage6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 7.16663L17.0379 17.5375"
      stroke={props.color || Colors.sage6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { CloseIcon, CloseMenuIcon, CloseIconThin };
